// Copyright 2025, University of Maryland, All Rights Reserved
import { useCallback, useMemo } from 'react'
import type { AnalysisPromptConfig } from '../types'
import type { ConfigUpdater } from './useAnalysisPromptState'
import type { DatasetDefinition } from '@/subsystems/pipelines/types'

interface UseDatasetStateParams {
  analysisConfig: AnalysisPromptConfig
  updateConfig: ConfigUpdater
  datasets: DatasetDefinition[]
}

export const useDatasetState = ({
  analysisConfig,
  updateConfig,
  datasets,
}: UseDatasetStateParams) => {
  const datasetKey = (analysisConfig.datasetKey as string) ?? ''

  const datasetList = useMemo(
    () => [...datasets].sort((a, b) => a.label.localeCompare(b.label)),
    [datasets],
  )

  const handleDatasetKeyChange = useCallback(
    (key: string) => updateConfig({ datasetKey: key }),
    [updateConfig],
  )

  return {
    datasetKey,
    datasetList,
    handlers: {
      handleDatasetKeyChange,
    },
  }
}
